import React from 'react';
import { motion } from 'framer-motion';
export const TrustSection = () => {
  const brands = ['Psychology Today', 'Wired', 'TechCrunch', 'The Verge', 'Vice'];
  return <section className="py-12 border-y border-gray-900 bg-[#050505] relative overflow-hidden" data-id="element-3237">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-3238">
        <p className="text-center text-gray-500 text-sm font-medium tracking-wide mb-8" data-id="element-3239">
          Trusted by thousands for relationship clarity
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-40 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-3240">
          {brands.map((brand, index) => <motion.div key={brand} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="text-lg md:text-xl font-bold text-gray-400 hover:text-white transition-colors" data-id="element-3241">
              {brand}
            </motion.div>)}
        </div>
      </div>
    </section>;
};